export default class DownloadCsv {
    configure (config) {
        this.headdata = ''
        this.bodydata = ''
        this.fileName = ''
        this.fileType = 'csv'
        this.fileContentType = 'text/csv'
        this.options = config
    }

  static install = (Vue, options) => {
      Object.defineProperty(Vue.prototype, '$downloadCsv', {
          get () { return this.$root._downloadCsv }
      })

      Vue.mixin({
          data () {
              return {
                  headdata: '',
                  bodydata: ''
              }
          },
          beforeCreate () {
              if (this.$options.downloadCsv) {
                  this._downloadCsv = this.$options.downloadCsv
                  this._downloadCsv.configure(options)
              }
          },
          created () {
          }
      })
  }

  // csv変換
  dataToTxt (data, headdata) {
      // サンプル
      // let headdata = '"球種","投球数","ボールスピード","","ボールスピン","","","ボール変化量","","","奥行","リリース","",""'
      //   +'\n'+'"","(球)","(km/h)","(％)","回転速度(rpm)","α(°)","有効回転速度","縦(cm)","横(cm)","角度(°)","","高(cm)","横(cm)","エクステンション(cm)"'
      let txtdata = ''
      this.headdata = headdata
      this.bodydata = data
      txtdata = this.headdata + this.bodydata
      if (typeof data !== 'undefined') {
          let date = Number(new Date())
          let filename = 'report-' + date + '.csv'
          this.downloadAsFile(filename, txtdata)
      }
  }

  // ファイルダウンロード
  downloadAsFile (fileName, content) {
      let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      let blob = new window.Blob([bom, content], { type: 'text/csv' })

      if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, fileName)
      } else if (window.navigator.userAgent.toLowerCase().indexOf('chrome') !== -1) {
          let url = window.URL || window.webkitURL
          let blobURL = url.createObjectURL(blob)
          let a = document.createElement('a')
          a.download = fileName
          a.href = blobURL
          a.click()
      } else {
          window.open(window.URL.createObjectURL(blob), 'mapwindow', 'width=10, height=10, menubar=no, toolbar=no, scrollbars=no, resizable=no')
      }
  }
}
